import { DateTime } from 'luxon';

import { DateHelper } from '../helpers/DateHelper';
import { OPTION_TYPES } from '../helpers/ShippingOptionHelper';

class ShippingOption {
  static classifyOption(option) {
    if (option.timeSlots && !option.agencies) {
      return OPTION_TYPES.SPECIAL;
    } else if (option.timeSlots && option.agencies) {
      return OPTION_TYPES.AGENCY;
    }
    return OPTION_TYPES.SIMPLE;
  }

  constructor(params) {
    this.acceptedPaymentMethods = params.acceptedPaymentMethods;
    this.optionType = ShippingOption.classifyOption(params);
    this.price = params.price;
    this.shippingType = params.shippingType;
    if (this.optionType === OPTION_TYPES.SIMPLE) {
      this.id = `${this.optionType}-${params.date}-${params.startHour}-${params.endHour}`;
      this.date = DateTime.fromISO(params.date);
      // this.unix = DateTime.fromISO(params.date).toUnixInteger();
      this.startHour = params.startHour;
      this.endHour = params.endHour;
      this.startHourString = DateHelper.militaryHourToString(this.startHour);
      this.endHourString = DateHelper.militaryHourToString(this.endHour);
    } else if (this.optionType === OPTION_TYPES.SPECIAL) {
      this.id = `${this.optionType}-${params.name}`;
      this.timeSlots = params.timeSlots.map(timeSlot => ({
        id: `${timeSlot.date}-${timeSlot.startHour}-${timeSlot.endHour}`,
        date: DateTime.fromISO(timeSlot.date),
        // unix: DateTime.fromISO(timeSlot.date).toUnixInteger(),
        startHour: timeSlot.startHour,
        endHour: timeSlot.endHour,
        startHourString: DateHelper.militaryHourToString(timeSlot.startHour),
        endHourString: DateHelper.militaryHourToString(timeSlot.endHour),
      }));
    } else if (this.optionType === OPTION_TYPES.AGENCY) {
      this.id = `${this.optionType}-${params.name}`;
      this.name = params.name;
      this.agencies = params.agencies.map(agency => ({
        extraCost: agency.extraCost,
        id: agency.id,
        name: agency.name,
      }));
      this.timeSlots = params.timeSlots.map(timeSlot => ({
        id: `${timeSlot.date}-${timeSlot.startHour}-${timeSlot.endHour}`,
        date: DateTime.fromISO(timeSlot.date),
        // unix: DateTime.fromISO(timeSlot.date).toUnixInteger(),
        startHour: timeSlot.startHour,
        endHour: timeSlot.endHour,
        startHourString: DateHelper.militaryHourToString(timeSlot.startHour),
        endHourString: DateHelper.militaryHourToString(timeSlot.endHour),
      }));
    }
  }
}

export { ShippingOption, OPTION_TYPES };



// WEBPACK FOOTER //
// ./src/models/ShippingOption.js